import { AppUtils } from '../../../../../shared/utils/index';
import { User } from "../../../../../shared/models/api/User/User";
import { PersonalDataModel } from "../../../../../shared/models/view/PersonalData";

export class AppFormModel {
	constructor(initialProperties?: Partial<AppFormModel>) {
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}

		this.personalData = new PersonalDataModel();
	}

	private personalData: PersonalDataModel;
	private ip: string;
	private processId: number;

	public get PersonalData(): PersonalDataModel {
		return this.personalData;
	}
	public set PersonalData(value: PersonalDataModel) {
		this.personalData = value;
	}

	public get Ip(): string {
		return this.ip;
	}

	public set Ip(value: string) {
		this.ip = value;
	}

	public get ProcessId(): number {
		return this.processId;
	}

	public set ProcessId(value: number) {
		this.processId = value;
	}

	/**
	 * Takes over fields from the user object, if not already filled in the model.
	 * Non editable fields are always filled from the user.
	 *
	 * @param user the user object to merge. May be null or empty.
	 * @param baseDataEditable flag, whether the base data (Anrede, Vorname, Nachnachme, Geburtsdatum) are editable.
	 * @return the calculator model itself for convenient usage.
	 */
	public mergeWithUser(user: User, baseDataEditable = false, advertisingMode = false): AppFormModel {
		if (user && user.Valid) {
			this.PersonalData.mergeWithUser(user, baseDataEditable, advertisingMode);
			this.personalData.TelefonNummer = `${this.PersonalData.TelefonVorwahl}${this.PersonalData.TelefonNummer}`;
			this.personalData.TelefonGeschaeftlichNummer = `${this.PersonalData.TelefonGeschaeftlichVorwahl}${this.PersonalData.TelefonGeschaeftlichNummer}`;
		}
		return this;
	}

	public static createFromObject(dataObject: { [key: string]: any }): AppFormModel {
		return AppUtils.Helper.createFromMap(dataObject, AppFormModel, (key: string, value: any) => {
			switch (key) { //NOSONAR
				case 'personalData':
					return PersonalDataModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}